import Column from '@amzn/meridian/column';
import React, { FC } from 'react';
import { TranslationFunction } from '../../../components/blocks/localization';
import { ExtractionFinding } from '../../../types';
import { distinctFindings, findingKey, findingMessage } from '../poReviewFindings';
import { WarningSentence } from './WarningSentence';

// The findings on one part of the page

export type PoReviewFindingListProps = {
    t: TranslationFunction;
    findings: ExtractionFinding[];
    // Distinguishes findings carrying the same code on different parts of the document.
    keyPrefix: string;
    quotedValue?: string;
};

const PoReviewFindingList: FC<PoReviewFindingListProps> = ({ t, findings, keyPrefix, quotedValue }) => (
    <Column spacing={'xsmall'}>
        {distinctFindings(findings).map((finding) => (
            <WarningSentence
                key={findingKey(finding, keyPrefix)}
                text={findingMessage(t, finding, quotedValue ? { value: quotedValue } : undefined)}
            />
        ))}
    </Column>
);

export { PoReviewFindingList };
